/*
 * Copyright (c) 2014-2023 Inovalon, Inc. All Rights Reserved.
 * This computer program is CONFIDENTIAL and a TRADE SECRET of Inovalon, Inc.
 * The receipt or possession of this program does not convey any rights to use, reproduce or disclose
 * its contents in whole or in part, without the specific written consent of Inovalon, Inc.
 * Any use, reproduction or disclosure of this program without the express written consent of Inovalon, Inc.
 * is a violation of the copyright laws and may subject you to criminal prosecution.
 */
import { ICoverageDiscoveryResponseStateManager, ICLine, IMcoStatusAlertSectionViewModels } from '../../../../services/CoverageDiscoveryResponseStateManager/contracts'
import './MCOStatusAlertSection.scss'
import { observer } from 'mobx-react'
import React from 'react'
import { injectProperty } from '../../../../arc/configuration/ServiceLocator'
import { ICoverageDiscoveryResponseApiClient } from '../../../../services/CoverageDiscoveryResponseApiClient/contracts'
import { Container } from 'reactstrap'

export interface IMCOStatusAlertSectionProps {
	CoverageDiscoveryResponseStateManager: ICoverageDiscoveryResponseStateManager
}
interface IMCOStatusAlertSectionState {
	IsPageLoading: boolean
}

@observer
export class MCOStatusAlertSection extends React.Component<IMCOStatusAlertSectionProps, IMCOStatusAlertSectionState> {
	@injectProperty('ICoverageDiscoveryResponseApiClient')
	public readonly CoverageDiscoveryResponseApiClient!: ICoverageDiscoveryResponseApiClient

	constructor(props: Readonly<IMCOStatusAlertSectionProps>) {
		super(props)
		this.state = {
			IsPageLoading: true,
		}
	}
	componentDidMount(): void {
		this.setIsPageLoadState(false)
	}
	setIsPageLoadState(val: boolean) {
		this.setState({
			IsPageLoading: val,
		})
	}

	renderMcoStatusAlertSection(mcoStatusAlertSectionViewModels: IMcoStatusAlertSectionViewModels[]): any {
		return <tbody>{this.renderMcoStatusAlertData(mcoStatusAlertSectionViewModels)}</tbody>
	}

	renderMcoStatusAlertData(mcoStatusAlertSectionViewModels: IMcoStatusAlertSectionViewModels[]): any {
		const FULLNAME = 'FullName'
		const ADDRESS = 'Address'
		const MESSAGE = 'Message'
		const POLICYNUMBER = 'PolicyNumber'
		const STARTDATE = 'StartDate'
		const ENDDATE = 'EndDate'
		const PLANDESCRIPTION = 'PlanDescription'
		const SERVICETYPE = 'ServiceType'
		const TELEPHONE = 'Telephone'
		let lines: Array<ICLine> = []

		let lineIndex = 1
		return mcoStatusAlertSectionViewModels.map(eligibilityBenefit => {
			lineIndex = eligibilityBenefit.id

			lines = eligibilityBenefit.cLineList
			let index = 0

			if (lines.length > 0) {
				return lines.map((line, uniqueIndex) => {
					const rowClass = index + 1 === lines.length ? 'bottom-border-td' : ''
					let rowIdentifier = ''
					let first = ''
					let second = ''
					for (let i = 0; i < line.sections.length; i++) {
						if (i === 0) {
							let label = ''
							switch (line.sections[i].value) {
								case FULLNAME:
									label = 'MCO/MCC Name'
									break
								case ADDRESS:
									label = 'Address'
									break
								case MESSAGE:
									label = 'Message'
									break
								case POLICYNUMBER:
									label = 'Policy #'
									break
								case STARTDATE:
									label = 'Eligibility Begin'
									break
								case ENDDATE:
									label = 'Eligibility End'
									break
								case PLANDESCRIPTION:
									label = 'Plan Description'
									break
								case SERVICETYPE:
									label = 'Service Type'
									break
								case TELEPHONE:
									label = 'Telephone'
									break

								default:
									break
							}
							first = label + ':'
							rowIdentifier = 'MCO' + lineIndex + '-' + label
						} else {
							second += line.sections[i].value
						}
					}
					index++
					return (
						<tr key={uniqueIndex} className={rowIdentifier}>
							<td className={rowClass}>{first}</td>
							<td className={rowClass} colSpan={3}>
								<span>{second}</span>
							</td>
						</tr>
					)
				})
			}
			return <></>
		})
	}
	render(): React.ReactNode {
		const mcoStatusAlertSection = this.props.CoverageDiscoveryResponseStateManager.selectedMcoStatusAlert

		if (mcoStatusAlertSection && mcoStatusAlertSection.mcoStatusAlertSectionViewModels && mcoStatusAlertSection.mcoStatusAlertSectionViewModels.length !== 0) {
			return (
				<div id="tblMCOSection" className="cdResponsePage">
					<Container style={{ margin: 0, padding: 0, width: '100%' }}>
						<table className="service-types-table">
							<thead>
								<tr className="MCO-header">
									<td colSpan={4} style={{ paddingLeft: '10px' }}>
										<h4>MCO Status Alert</h4>
									</td>
								</tr>
							</thead>
							{this.renderMcoStatusAlertSection(mcoStatusAlertSection.mcoStatusAlertSectionViewModels)}
						</table>
					</Container>
				</div>
			)
		}
		return null
	}
}
